module.exports = __webpack_public_path__ + "img/approve 1.ab823d81.png";